@defer (when this.ready){
    <div class="flex flex-col justify-between min-h-screen">
        <app-loading class="ease-in-out" [class.hidden]="this.ready" [@readyState]="!this.ready ? 'fadeIn' : 'fadeOut'"/>
        <div class="block container ease-in-out min-h-full" [class.hidden]="!this.ready "  [@readyState]="this.ready  ? 'fadeIn' : 'fadeOut'">
            @if (!inPreviewMode || (isLoggedIn && isPreviewUser)){
                <app-menu />
            }
            <div class="flex h-full">
                
                <div class="w-full min-h-full">
                <!-- <div [@routeTransition]="this?.route?.snapshot?.data"> -->
                        <router-outlet class="min-h-full"  />

                <!-- </div> -->
                </div>
            </div>
        </div>
        @if (displayFooter && (!inPreviewMode || isLoggedIn)){
            <app-footer class="mt-3" />
        }
    </div>
    @if (isAdminUser){
        <app-admin-menu />
    }
}
@placeholder () {
    <app-loading [@readyState]="!this.ready ? 'fadeIn' : 'fadeOut'"/>
}
 <p-toast />   
